import React, { useEffect, useState } from "react";
import MaterialTable, { MTableToolbar } from "material-table";
import { useNavigate } from "react-router-dom";
import SlidingPane from "react-sliding-pane";
import "react-sliding-pane/dist/react-sliding-pane.css";
import ContentLoader from "react-content-loader";
import _ from "lodash";
import jsPDF from "jspdf";
import { autoTable } from 'jspdf-autotable';
import Select from 'react-select';
import axios from "axios";

import { API } from "../../../backend";
import authHeader from "../../../services/auth-header";
import Helper from "../../../Helper";
import { getTrans as t } from "../../../Localization/translations";
import lineOfBusinessService from "../../../services/company/lineofbusinessService";
import subcompanyService from "../../../services/company/subcompanyService";

function DataTapeReport({ id }) {
  const tableRef = React.createRef();
  var contractNumber = "";
  var customerName = "";
  
  // --- STATES ---
  const [loading, setLoading] = useState(true);
  const [permissionss, setPermission] = useState(localStorage.getItem('permissions'));
  const permissionsArray = permissionss ? permissionss.split(',') : [];
  
  const [state1, setState] = useState({
    isPaneOpen: false,
    isPaneOpenLeft: false,
  });

  const [selectedValue, setSelectedValue] = useState(null);
  const [options, setOptions] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [isLoading, setIsLoading] = useState(false);
  const [inputValue, setInputValue] = useState('');

  const [selectedValue2, setSelectedValue2] = useState(null);
  const [isLoading2, setIsLoading2] = useState(false);
  const [inputvalue2, setValue2] = useState("");
  const [currentPage2, setCurrentPage2] = useState(1);
  const [options2, setOptions2] = useState([]);

  const [totalnetinvestment, setTotalNetInvestment] = useState(0);

  const [subcompany, setSubcompany] = useState("");
  const [lineOfBusiness, setLineOfBusiness] = useState("");
  const [subcompanyOptions, setSubcompanyOptions] = useState([]);
  const [lineOfBusinessOptions, setLineOfBusinessOptions] = useState([]);

  // --- NEW DROPDOWN STATES ---
  const [availableDates, setAvailableDates] = useState([]);
  const [asOfDate, setAsOfDate] = useState("");
  const [isDatesLoading, setIsDatesLoading] = useState(true);

  let navigate = useNavigate();

  // --- DATA FETCHING EFFECTS ---
  const fetchSubcompanies = () => {
    try {
      subcompanyService.getSubcompany().then((response) => {
        const companies = response.data || [];
        setSubcompanyOptions(companies);
      });
    } catch (err) {
      console.error(err);
    }
  };

  const fetchLinesOfBusiness = () => {
    try {
      lineOfBusinessService.getLineOfBusiness().then((response) => {
        const lobs = response.data || [];
        setLineOfBusinessOptions(lobs);
      });
    } catch (err) {
      console.error(err);
    }
  };

  useEffect(() => {
    fetchSubcompanies();
    fetchLinesOfBusiness();
    setLoading(false); 
  }, []);

  // Fetch the generated Snapshot Dates for the Dropdown
  useEffect(() => {
    axios.get(API + 'accounting/data-tape-dates/', { headers: authHeader() })
      .then(response => {
        const dates = response.data.dates || [];
        setAvailableDates(dates);
        
        // Automatically select the newest generated month if available
        if (dates.length > 0) {
          setAsOfDate(dates[0]); 
        }
        setIsDatesLoading(false);
      })
      .catch(error => {
        console.error("Error fetching Data Tape dates:", error);
        setIsDatesLoading(false);
      });
  }, []);

  // --- HELPER FUNCTIONS ---

  const handlePayNetExport = async () => {
    if (!asOfDate) {
      alert(t("Please select an As Of Date first."));
      return;
    }
    
    try {
      const response = await axios.get(`${API}accounting/paynet-export/?as_of_date=${asOfDate}&agency_code=PAYNET`, {
        headers: authHeader(),
        responseType: 'blob', 
      });

      const disposition = response.headers['content-disposition'];
      let filename = 'paynet_export.txt';
      if (disposition && disposition.indexOf('filename=') !== -1) {
        const matches = /filename="([^"]+)"/.exec(disposition);
        if (matches != null && matches[1]) {
          filename = matches[1];
        }
      }

      const urlBlob = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement('a');
      link.href = urlBlob;
      link.setAttribute('download', filename);
      document.body.appendChild(link);
      link.click();
      
      document.body.removeChild(link);
      window.URL.revokeObjectURL(urlBlob);

    } catch (error) {
      console.error("Error exporting PayNet file:", error);
      alert(t("Failed to generate PayNet export. Please ensure snapshots exist for this date."));
    }
  };

  const fetchAllDataForExport = async () => {
    let allData = [];
    let currentPage = 0;
    const pageSize = 50;

    let contractNumberParam = "";
    let customerNameParam = "";
    let subcompanyParam = subcompany || "";
    let lineOfBusinessParam = lineOfBusiness || "";

    if (selectedValue2 && selectedValue) {
        contractNumberParam = selectedValue2.contract_number;
        customerNameParam = selectedValue.customer_name;
    } else if (selectedValue2) {
        contractNumberParam = selectedValue2.contract_number;
    } else if (selectedValue) {
        customerNameParam = selectedValue.customer_name;
    }

    while (true) {
        const url = `${API}accounting/data-tape/?per_page=${pageSize}&page=${currentPage + 1}&search=${inputValue}&contractNumber=${contractNumberParam}&customerName=${customerNameParam}&subcompany=${subcompanyParam}&line_of_business=${lineOfBusinessParam}&as_of_date=${asOfDate}&status=Active`;
        try {
            const response = await fetch(url, { headers: authHeader() });
            const result = await response.json();

            if (!result.data || result.data.length === 0) {
                break;
            }

            allData = allData.concat(result.data);
            currentPage++;
        } catch (error) {
            console.error("Error fetching data:", error);
            break;
        }
    }
    
    // Filter out rental contracts directly in the frontend export
    const filteredData = allData.filter(row => row.contract_type === "Lease" || row.contract_type === "Loan" || row.contract_type === "Line of Credit");
    return filteredData.sort((a, b) => {
        return b.contract_number.toString().localeCompare(a.contract_number.toString());
    });
  };

  const handelInputChange = (value) => {
    setInputValue(value);
    setCurrentPage(1);
    setOptions([]);
    loadOptions(value, 1);
  };

  const handleMenuScrollToBottomName = () => {
    loadOptions(inputValue, currentPage);
  };

  const handelChange = (value) => {
    setSelectedValue(value);
  };

  const loadOptions = async (value, page) => {
    try {
      if (value !== '') {
        setIsLoading(true);
        const response = await fetch(`${API}parties/party/?customer_name=${value}&page=${page}`, { headers: authHeader() });
        const newData = await response.json();

        if (newData && newData.data && newData.data.length > 0) {
          const newOptions = newData.data;
          setOptions((prevOptions) => [...prevOptions, ...newOptions]);
          setCurrentPage((prevPage) => prevPage + 1);
        }
        setIsLoading(false);
      }
    } catch (error) {
      console.error('Error fetching data:', error);
      setIsLoading(false);
    }
  };

  const handleClear = () => {
    setSelectedValue2(null);
    setSelectedValue(null);
    setSubcompany("");
    setLineOfBusiness("");
    tableRef.current.onQueryChange();
  };

  const handleView = (id) => {
    navigate("/contract/view", { state: id });
  };

  const handlePartyView = (id) => {
    navigate("/party/details", { state: id });
  };

  const handleInputChangeData = (value) => {
    setValue2(value);
    setCurrentPage2(1);
    setOptions2([]);
    loadOptionsData(value, 1);
  };

  const handleMenuScrollToBottom = () => {
    loadOptionsData(inputvalue2, currentPage2);
  };

  const loadOptionsData = async (value, page) => {
    try {
      if (value !== '') {
        setIsLoading2(true);
        const response = await fetch(`${API}contracts/contractsactive/filter/?id=${value}&page=${page}`, { headers: authHeader() });
        const newData = await response.json();

        if (newData && newData.data && newData.data.length > 0) {
          const newOptions = newData.data;
          setOptions2((prevOptions) => [...prevOptions, ...newOptions]);
          setCurrentPage2((prevPage) => prevPage + 1);
        }
        setIsLoading2(false);
      }
    } catch (error) {
      console.error('Error fetching data:', error);
      setIsLoading2(false);
    }
  };

  const handelChange2 = (value1) => {
    setSelectedValue2(value1);
  };

  function getAlignmentStyles(columns) {
    const alignmentStyles = {};
    columns.forEach((columnDef, index) => {
        if (['original_amount_financed', 'outstanding_balance', 'payment_amount', 'residual_value', 'original_equipment_cost'].includes(columnDef.field)) {
            alignmentStyles[index] = { halign: 'right' }; 
        } else {
            alignmentStyles[index] = { halign: 'left' }; 
        }
    });
    return alignmentStyles;
  }

  const renderTextCol = (title, field) => ({
    title: `${t(title)}`,
    field: field,
    render: (rowData) => (
      <>
        <div className="d-xl-none tc d-md-none d-lg-none">{t(title)}</div>
        <div>{rowData[field] !== null && rowData[field] !== undefined && rowData[field] !== "" ? rowData[field] : "-"}</div>
      </>
    ),
    headerStyle: { verticalAlign: "inherit", fontWeight: "bold", textAlign: "left", whiteSpace: "nowrap" },
    cellStyle: { textAlign: "left", fontSize: 12, whiteSpace: "nowrap" },
  });

  const renderDateCol = (title, field) => ({
    title: `${t(title)}`,
    field: field,
    render: (rowData) => (
      <>
        <div className="d-xl-none tc d-md-none d-lg-none">{t(title)}</div>
        <div>{rowData[field] ? Helper.DateNormal(rowData[field]) : "None"}</div>
      </>
    ),
    headerStyle: { verticalAlign: "inherit", fontWeight: "bold", textAlign: "left", whiteSpace: "nowrap" },
    cellStyle: { textAlign: "left", fontSize: 12, whiteSpace: "nowrap" },
  });

  const renderAmountCol = (title, field) => ({
    title: `${t(title)}`,
    field: field,
    render: (rowData) => (
      <>
        <div className={`d-xl-none tc d-md-none d-lg-none`} style={{ textAlign: rowData.isSmallScreen ? 'left' : 'right', fontSize: '12px', fontWeight: rowData.isSmallScreen ? 'bold' : '' }}>
          {t(title)}
        </div>
        <div className={`d-none d-xl-block d-lg-block text-right`} style={{ textAlign: 'right', fontSize: '12px', whiteSpace: "nowrap" }}>
          {Helper.Amount(rowData[field] || 0)}
        </div>
      </>
    ),
    headerStyle: { verticalAlign: "inherit", fontWeight: "bold", textAlign: "right", whiteSpace: "nowrap" },
    cellStyle: { whiteSpace: "nowrap" },
  });

  return (
    <>
      <div className="page-wrapper">
        <div className="">
          {loading === false ? (
            <div className="row show_contract show_invoice">
              <div className="col-md-12">
                <div className=" mb-0">
                  <div className="body">
                    <div className="table-responsive p-0">
                      <MaterialTable
                        tableRef={tableRef}
                        style={{
                          backgroundColor: "var(--bs-table-bg)",
                          borderBottomWidth: "1px",
                          boxShadow: "inset 0 0 0 9999px var(--bs-table-accent-bg)",
                        }}
                        title={<h5>{t("Data Tape")}
                        {/* <div className="mt-2">
                          <span style={{ fontSize: "14px", fontWeight: "bold", color: "#245C7F" }}> {t("Total Net Investment")} </span>
                          <span className="" style={{ fontSize: "14px"}} > : {Helper.Amount(totalnetinvestment)}</span>
                        </div> */}
                        </h5>}
                        columns={[
                          renderTextCol("Lender ID", "lender_id"),
                          // renderTextCol("Branch ID", "branch_id"),
                          renderTextCol("Company Name", "company_name"),
                          renderTextCol("Line of Business", "line_of_business"),
                          renderDateCol("Reporting Date", "reporting_date"),
                          {
                            title: `${t("Customer Name")}`,
                            field: "customer_name",
                            render: (rowData) => (
                              <>
                                <div className="d-xl-none tc d-md-none d-lg-none">{t("Customer Name")}</div>
                                <div 
                                  className="hyperlink" 
                                  onClick={() => {
                                    if (permissionss && permissionsArray.includes('view_party') && rowData.party_id) {
                                      handlePartyView(rowData.party_id);
                                    }
                                  }}
                                >
                                  {rowData.customer_name}
                                </div>
                              </>
                            ),
                            headerStyle: { verticalAlign: "inherit", fontWeight: "bold", textAlign: "left" },
                            cellStyle: { textAlign: "left", fontSize: 12 },
                          },
                          renderTextCol("DBA", "dba"),
                          renderTextCol("Tax ID (EIN/SSN)", "TIN_number"),
                          renderTextCol("Address", "address"),
                          renderTextCol("City", "city"),
                          renderTextCol("State", "state"),
                          renderTextCol("ZIP", "zip_code"),
                          renderTextCol("Country", "country"),
                          {
                            title: `${t("Contract Number")}`,
                            field: "contract_number",
                            defaultSort: "desc",
                            render: (rowData) => (
                              <>
                                <div className="d-xl-none tc d-md-none d-lg-none">{t("Contract Number")}</div>
                                <div 
                                  className="hyperlink" 
                                  onClick={() => {
                                    if (rowData.contract_id) {
                                      handleView(rowData.contract_id);
                                    } else {
                                      console.warn("Still missing! Check Django server logs.");
                                    }
                                  }}
                                >
                                  {rowData.contract_number}
                                </div>
                              </>
                            ),
                            headerStyle: { verticalAlign: "inherit", fontWeight: "bold", textAlign: "left" },
                            cellStyle: { textAlign: "left", fontSize: 12 },
                          },
                          renderTextCol("Contract Type", "contract_type"),
                          renderDateCol("Original Contract Date", "original_contract_date"),
                          renderDateCol("Booking Date", "booking_date"),
                          renderTextCol("Equipment Type", "equipment_type"),
                          renderTextCol("Equipment Category", "equipment_category"),
                          {
                            title: t("NAICS Code"),
                            field: "industry_code",
                            render: (rowData) => {
                              const code = (rowData.industry_code || "").toString().replace(/-/g, "").trim();
                              return (
                                <>
                                  <div className="d-xl-none tc d-md-none d-lg-none">{t("NAICS Code")}</div>
                                  <div>{code.length === 6 ? code : ""}</div>
                                </>
                              );
                            },
                            headerStyle: { verticalAlign: "inherit", fontWeight: "bold", textAlign: "left", whiteSpace: "nowrap" },
                            cellStyle: { textAlign: "left", fontSize: 12, whiteSpace: "nowrap" },
                          },
                          {
                            title: t("SIC Code"),
                            field: "industry_code",
                            render: (rowData) => {
                              const code = (rowData.industry_code || "").toString().replace(/-/g, "").trim();
                              return (
                                <>
                                  <div className="d-xl-none tc d-md-none d-lg-none">{t("SIC Code")}</div>
                                  <div>{code.length === 4 ? code : ""}</div>
                                </>
                              );
                            },
                            headerStyle: { verticalAlign: "inherit", fontWeight: "bold", textAlign: "left", whiteSpace: "nowrap" },
                            cellStyle: { textAlign: "left", fontSize: 12, whiteSpace: "nowrap" },
                          },
                          renderTextCol("New/Used Indicator", "new_used_indicator"),
                          renderAmountCol("Original Amount Financed", "original_amount_financed"),
                          renderAmountCol("Current Balance", "outstanding_balance"),
                          renderAmountCol("Payment Amount", "payment_amount"),
                          renderTextCol("Payment Frequency", "payment_frequency"),
                          {
                            title: `${t("Interest Rate")}`,
                            field: "interest_rate",
                            render: (rowData) => (
                              <>
                                <div className={`d-xl-none tc d-md-none d-lg-none`} style={{ textAlign: rowData.isSmallScreen ? 'left' : 'right', fontSize: '12px', fontWeight: rowData.isSmallScreen ? 'bold' : '' }}>
                                  {t("Interest Rate")}
                                </div>
                                <div className={`d-none d-xl-block d-lg-block text-right`} style={{ textAlign: 'right', fontSize: '12px' }}>
                                  {rowData.interest_rate || 0}%
                                </div>
                              </>
                            ),
                            headerStyle: { verticalAlign: "inherit", fontWeight: "bold", textAlign: "right" },
                          },
                          renderAmountCol("Residual Value", "residual_value"),
                          {
                            title: `${t("Status")}`,
                            field: "status",
                            render: (rowData) => (
                              <>
                                <div className="d-xl-none tc d-md-none d-lg-none">{t("Status")}</div>
                                <div className={rowData.status === "Active" ? "badge bg-gradient-success text-xxs" : rowData.status === "Terminated" || rowData.status === "PaidOff" ? "badge bg-gradient-danger text-xxs" : "badge badge-sm bg-gradient-secondary"}>
                                  {rowData.status}
                                </div>
                              </>
                            ),
                            headerStyle: { verticalAlign: "inherit", fontWeight: "bold", textAlign: "left" },
                            cellStyle: { textAlign: "left", fontSize: 12 },
                          },
                          renderDateCol("Current Due Date", "current_due_date"),
                          renderDateCol("Maturity Date", "maturity_date"),
                          renderTextCol("Legal Business Name", "legal_business_name"),
                          renderTextCol("State Of Incorporation", "state_of_incorporation"),
                          renderTextCol("Asset Class", "asset_class"),
                          renderAmountCol("Original Equipment Cost", "original_equipment_cost"),
                          renderTextCol("Original Term", "original_term"),
                          renderTextCol("Remaining Term", "remaining_term"),
                          renderTextCol("Days Past Due", "days_past_due"),
                          renderTextCol("VIN/Serial Number", "serial_number"),
                          renderTextCol("Fixed/Floating Indicator", "fixed_floating_indicator"),
                        ]}
                        data={permissionss && permissionsArray.includes('view_contract') === true ? (query) =>
                          new Promise((resolve, reject) => {
                            const { orderBy, orderDirection } = query;
                            let subcompanyParam = subcompany || "";
                            let lineOfBusinessParam = lineOfBusiness || "";
                            if (selectedValue2 && selectedValue) {
                              contractNumber = selectedValue2.contract_number;
                              customerName = selectedValue.id;
                            } else if (selectedValue2) {
                              contractNumber = selectedValue2.contract_number;
                            } else if (selectedValue) {
                              customerName = selectedValue.id;
                            }
                            let url = API + "accounting/data-tape/?";
                            url += "status=Active";
                            url += "&per_page=" + query.pageSize;
                            url += "&page=" + (query.page + 1);
                            url += "&search=" + query.search;
                            url += `&contractNumber=${contractNumber !== "" ? contractNumber : ""}`;
                            url += `&customerName=${customerName !== "" ? customerName : ""}`;
                            url += `&subcompany=${subcompanyParam}`;
                            url += `&line_of_business=${lineOfBusinessParam}`;
                            
                            // Dynamically append the dropdown date
                            if (asOfDate) {
                              url += `&as_of_date=${asOfDate}`;
                            }

                            if (orderBy) {
                              url += `&orderBy=${orderBy.field}`;
                              url += `&orderDirection=${orderDirection}`;
                            }
                            fetch(url, { headers: authHeader() })
                              .then((response) => response.json())
                              .then((result) => {
                                setTotalNetInvestment(result.total_net_investment || 0);
                                resolve({
                                  data: query.orderBy && query.orderDirection ? _.orderBy(result.data, [query.orderBy.field], [query.orderDirection]) : result.data,
                                  page: result.page - 1,
                                  totalCount: result.total,
                                });
                              });
                          })
                          : []
                        }
                        actions={[
                          {
                            icon: 'text_snippet',
                            tooltip: t('PayNet Export (.txt)'),
                            isFreeAction: true,
                            onClick: () => handlePayNetExport()
                          }
                        ]}
                        components={{
                          Action: (props) => (
                            <button
                              type="button"
                              onClick={(event) => props.action.onClick(event, props.data)}
                              className="btn btn-primary btn-sm mb-0 ms-2"
                              style={{ padding: "5px 10px", fontSize: "10px", lineHeight: "1.5" }}
                            >
                              {props.action.tooltip}
                            </button>
                          ),
                          Toolbar: (props) => (
                            <div className="MuiToolbar-root MTableToolbar-spacer-21 my-temp-class">
                              <MTableToolbar {...props} />
                              <span
                                onClick={() => setState({ isPaneOpen: true })}
                                style={{ color: "#b4b7c5", paddingRight: "15px", paddingLeft: "10px", cursor: "pointer" }}
                              >
                                <img src={process.env.PUBLIC_URL + "/static/images/ic-filter.svg"} alt="" />
                              </span>
                            </div>
                          ),
                        }}
                        options={{
                          headerStyle: { backgroundColor: "white", color: "#245C7F", fontSize: 12 },
                          rowStyle: (rowData, index) => {
                            if (index % 2) return { backgroundColor: "#fff" };
                          },
                          sorting: true,
                          search: true,
                          toolbar: true,
                          paging: true,
                          pageSize: 10,
                          emptyRowsWhenPaging: false,
                          pageSizeOptions: [10, 25, 50, 100],
                          paginationType: "stepped",
                          showFirstLastPageButtons: false,
                          exportAllData: true,
                          exportButton: true,
                          exportFileName: "Data Tape Report",
                          
                          exportCsv: async (columns, data) => {
                            try {
                              const allData = await fetchAllDataForExport(); 
                              if (!allData || allData.length === 0) return;

                              const exportSchema = [
                                { title: "Lender ID", field: "" },
                                // { title: "Branch ID", field: "" },
                                { title: "Company Name", field: "company_name" },
                                { title: "Line of Business", field: "line_of_business" },
                                { title: "Reporting Date", field: "reporting_date" },
                                { title: "Customer Name", field: "customer_name" },
                                { title: "DBA", field: "dba" },
                                { title: "Tax ID (EIN/SSN)", field: "TIN_number" },
                                { title: "Address", field: "address" },
                                { title: "City", field: "city" },
                                { title: "State", field: "state" },
                                { title: "ZIP", field: "zip_code" },
                                { title: "Country", field: "country" },
                                { title: "Contract Number", field: "contract_number" },
                                { title: "Contract Type", field: "contract_type" },
                                { title: "Original Contract Date", field: "original_contract_date" },
                                { title: "Booking Date", field: "booking_date" },
                                { title: "Equipment Type", field: "equipment_type" },
                                { title: "Equipment Category", field: "equipment_category" },
                                { title: "NAICS Code", field: "naics_code" },
                                { title: "SIC Code", field: "sic_code" },
                                { title: "New/Used Indicator", field: "new_used_indicator" },
                                { title: "Original Amount Financed", field: "original_amount_financed" },
                                { title: "Current Balance", field: "outstanding_balance" },
                                { title: "Payment Amount", field: "payment_amount" },
                                { title: "Payment Frequency", field: "payment_frequency" },
                                { title: "Interest Rate", field: "interest_rate" },
                                { title: "Residual Value", field: "residual_value" },
                                { title: "Status", field: "status" },
                                { title: "Current Due Date", field: "current_due_date" },
                                { title: "Maturity Date", field: "maturity_date" },
                                { title: "Legal Business Name", field: "legal_business_name" },
                                { title: "State Of Incorporation", field: "state_of_incorporation" },
                                { title: "Asset Class", field: "asset_class" },
                                { title: "Original Equipment Cost", field: "original_equipment_cost" },
                                { title: "Original Term", field: "original_term" },
                                { title: "Remaining Term", field: "remaining_term" },
                                { title: "Days Past Due", field: "days_past_due" },
                                { title: "VIN/Serial Number", field: "serial_number" },
                                { title: "Fixed/Floating", field: "fixed_floating_indicator" }
                              ];

                              const csvColumnTitles = exportSchema.map(col => col.title);
                              const title = "Data Tape Report";
                              const currentDate = new Date().toLocaleDateString();

                              let csvContentWithInfo = `${title}\n`;
                              if (selectedValue !== null) csvContentWithInfo += `Filter By Customer Name : ${selectedValue.customer_name}\n`;
                              if (selectedValue2 !== null) csvContentWithInfo += `Filter By Contract Number : ${selectedValue2.contract_number}\n`;
                              if (asOfDate) csvContentWithInfo += `As Of Date: ${Helper.DateNormal(asOfDate)}\n`;
                              csvContentWithInfo += `Exported On: ${currentDate}\n\n`;

                              const dateFields = ['reporting_date', 'original_contract_date', 'booking_date', 'current_due_date', 'maturity_date'];

                              const csvData = allData.map(rowData =>
                                exportSchema.map(col => {
                                  let value = rowData[col.field];
                                  if (col.title === "DBA") {
                                    value = rowData.dba || "";
                                  }
                                  if (col.field === "naics_code") {
                                    const code = (rowData.industry_code || "").toString().replace(/-/g, "").trim();
                                    value = code.length === 6 ? code : "";
                                  }
                                  if (col.field === "sic_code") {
                                    const code = (rowData.industry_code || "").toString().replace(/-/g, "").trim();
                                    value = code.length === 4 ? code : "";
                                  }
                                  if (dateFields.includes(col.field)) {
                                    return value ? Helper.DateNormal(value) : "";
                                  }
                                  if (typeof value === 'string') {
                                    value = value.replace(/(\r\n|\n|\r)/gm, " ");
                                    if (value.includes(",")) return `"${value}"`;
                                  }
                                  return value !== null && value !== undefined ? value : "";
                                })
                              );

                              const csvRows = [csvColumnTitles, ...csvData];
                              const csvContent = `${csvContentWithInfo}${csvRows.map(row => row.join(',')).join('\n')}`;

                              const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
                              const link = document.createElement('a');
                              link.href = URL.createObjectURL(blob);
                              link.download = 'datatape.csv';
                              link.style.display = 'none';
                              document.body.appendChild(link);
                              link.click();
                              document.body.removeChild(link);
                            } catch (error) {
                              console.error("Error exporting CSV:", error);
                            }
                          },
                          
                          exportPdf: async (columns, data) => {
                            const allData = await fetchAllDataForExport(); 
                            if (!allData || allData.length === 0) return;

                            const exportSchema = [
                                { title: "Lender ID", field: "lender_id" },
                                // { title: "Branch ID", field: "branch_id" },
                                { title: "Company Name", field: "company_name" },
                                { title: "Line of Business", field: "line_of_business" },
                                { title: "Reporting Date", field: "reporting_date" },
                                { title: "Customer Name", field: "customer_name" },
                                { title: "DBA", field: "dba" },
                                { title: "Tax ID", field: "TIN_number" },
                                { title: "Address", field: "address" },
                                { title: "City", field: "city" },
                                { title: "State", field: "state" },
                                { title: "ZIP", field: "zip_code" },
                                { title: "Country", field: "country" },
                                { title: "Contract Number", field: "contract_number" },
                                { title: "Contract Type", field: "contract_type" },
                                { title: "Original Contract Date", field: "original_contract_date" },
                                { title: "Booking Date", field: "booking_date" },
                                { title: "Equipment Type", field: "equipment_type" },
                                { title: "Equipment Category", field: "equipment_category" },
                                { title: "NAICS", field: "naics_code" },
                                { title: "SIC", field: "sic_code" },
                                { title: "New/Used", field: "new_used_indicator" },
                                { title: "Original Financed", field: "original_amount_financed" },
                                { title: "Current Balance", field: "amount_due" },
                                { title: "Payment Amount", field: "payment_amount" },
                                { title: "Payment Frequency", field: "payment_frequency" },
                                { title: "Interest Rate", field: "interest_rate" },
                                { title: "Residual Value", field: "residual_value" },
                                { title: "Status", field: "status" },
                                { title: "Current Due Date", field: "current_due_date" },
                                { title: "Maturity Date", field: "maturity_date" },
                                { title: "Legal Name", field: "legal_business_name" },
                                { title: "State Inc.", field: "state_of_incorporation" },
                                { title: "Asset Class", field: "asset_class" },
                                { title: "Equip. Cost", field: "original_equipment_cost" }
                            ];

                            const doc = new jsPDF('landscape');
                            doc.setFont("helvetica", "bold");
                            doc.setFontSize(16);
                            doc.text("Data Tape Report", 14, 10);
                            
                            doc.setFontSize(12);
                            doc.setFont("helvetica", "normal");
                            const currentDate = new Date().toLocaleDateString();
                            doc.text(`Date : ${currentDate}`, 14, 15);

                            let verticalOffset = 20;
                            let filterText = "";
                            if (selectedValue) filterText += `Customer: ${selectedValue.customer_name} | `;
                            if (selectedValue2) filterText += `Contract: ${selectedValue2.contract_number} | `;
                            if (asOfDate) filterText += `As Of Date: ${Helper.DateNormal(asOfDate)}`;
                            
                            if (filterText !== "") {
                                doc.text(`Filters: ${filterText}`, 14, verticalOffset);
                                verticalOffset += 7;
                            }

                            const columnTitles = exportSchema.map(col => col.title);
                            const dateFields = ['reporting_date', 'original_contract_date', 'booking_date', 'current_due_date', 'maturity_date'];

                            const pdfData = allData.map(rowData =>
                              exportSchema.map(columnDef => {
                                let value = rowData[columnDef.field];
                                if (columnDef.title === "DBA") {
                                value = rowData.dba || "";
                              }

                                if (columnDef.field === "naics_code") {
                                  const code = (rowData.industry_code || "").toString().replace(/-/g, "").trim();
                                  value = code.length === 6 ? code : "";
                                }
                                if (columnDef.field === "sic_code") {
                                  const code = (rowData.industry_code || "").toString().replace(/-/g, "").trim();
                                  value = code.length === 4 ? code : "";
                                }
                                
                                if (dateFields.includes(columnDef.field)) {
                                  return value ? Helper.DateNormal(value) : "";
                                }
                                if (['original_amount_financed', 'outstanding_balance', 'payment_amount', 'residual_value', 'original_equipment_cost'].includes(columnDef.field)) {
                                  return value || value === 0 ? Helper.Amount(value) : "";
                                }
                                return value !== null && value !== undefined ? value : "";
                              })
                            );

                            autoTable(doc, {
                              head: [columnTitles],
                              body: pdfData,
                              startY: verticalOffset,
                              columnStyles: getAlignmentStyles(exportSchema),
                              styles: { fontSize: 4.5, cellPadding: 0.5 },
                              overflow: 'linebreak'
                            });

                            doc.save(`datatape.pdf`);
                          },
                          actionsColumnIndex: -1,
                          columnsButton: true,
                        }}
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          ) : (
            <ContentLoader viewBox="0 0 1000 550" backgroundColor="rgba(0,0,0,0.06)" foregroundColor="rgba(0,0,0,0.12)">
              <rect x="51" y="45" rx="3" ry="3" width="906" height="17" />
              <circle cx="879" cy="123" r="11" />
              <circle cx="914" cy="123" r="11" />
              <rect x="104" y="115" rx="3" ry="3" width="141" height="15" />
              <rect x="305" y="114" rx="3" ry="3" width="299" height="15" />
              <rect x="661" y="114" rx="3" ry="3" width="141" height="15" />
              <rect x="55" y="155" rx="3" ry="3" width="897" height="2" />
              <circle cx="880" cy="184" r="11" />
              <circle cx="915" cy="184" r="11" />
              <rect x="105" y="176" rx="3" ry="3" width="141" height="15" />
              <rect x="306" y="175" rx="3" ry="3" width="299" height="15" />
              <rect x="662" y="175" rx="3" ry="3" width="141" height="15" />
              <rect x="56" y="216" rx="3" ry="3" width="897" height="2" />
              <circle cx="881" cy="242" r="11" />
              <circle cx="916" cy="242" r="11" />
              <rect x="106" y="234" rx="3" ry="3" width="141" height="15" />
              <rect x="307" y="233" rx="3" ry="3" width="299" height="15" />
              <rect x="663" y="233" rx="3" ry="3" width="141" height="15" />
              <rect x="57" y="274" rx="3" ry="3" width="897" height="2" />
              <circle cx="882" cy="303" r="11" />
              <circle cx="917" cy="303" r="11" />
              <rect x="107" y="295" rx="3" ry="3" width="141" height="15" />
              <rect x="308" y="294" rx="3" ry="3" width="299" height="15" />
              <rect x="664" y="294" rx="3" ry="3" width="141" height="15" />
              <rect x="58" y="335" rx="3" ry="3" width="897" height="2" />
              <circle cx="881" cy="363" r="11" />
              <circle cx="916" cy="363" r="11" />
              <rect x="106" y="355" rx="3" ry="3" width="141" height="15" />
              <rect x="307" y="354" rx="3" ry="3" width="299" height="15" />
              <rect x="663" y="354" rx="3" ry="3" width="141" height="15" />
              <rect x="57" y="395" rx="3" ry="3" width="897" height="2" />
              <circle cx="882" cy="424" r="11" />
              <circle cx="917" cy="424" r="11" />
              <rect x="107" y="416" rx="3" ry="3" width="141" height="15" />
              <rect x="308" y="415" rx="3" ry="3" width="299" height="15" />
              <rect x="664" y="415" rx="3" ry="3" width="141" height="15" />
              <rect x="55" y="453" rx="3" ry="3" width="897" height="2" />
              <rect x="51" y="49" rx="3" ry="3" width="2" height="465" />
              <rect x="955" y="49" rx="3" ry="3" width="2" height="465" />
              <circle cx="882" cy="484" r="11" />
              <circle cx="917" cy="484" r="11" />
              <rect x="107" y="476" rx="3" ry="3" width="141" height="15" />
              <rect x="308" y="475" rx="3" ry="3" width="299" height="15" />
              <rect x="664" y="475" rx="3" ry="3" width="141" height="15" />
              <rect x="55" y="513" rx="3" ry="3" width="897" height="2" />
              <rect x="52" y="80" rx="3" ry="3" width="906" height="17" />
              <rect x="53" y="57" rx="3" ry="3" width="68" height="33" />
              <rect x="222" y="54" rx="3" ry="3" width="149" height="33" />
              <rect x="544" y="55" rx="3" ry="3" width="137" height="33" />
              <rect x="782" y="56" rx="3" ry="3" width="72" height="33" />
              <rect x="933" y="54" rx="3" ry="3" width="24" height="33" />
            </ContentLoader>
          )}
        </div>
      </div>
      <SlidingPane
        className="some-custom-class"
        overlayClassName="some-custom-overlay-class"
        isOpen={state1.isPaneOpen}
        title="Filter By"
        subtitle=""
        onRequestClose={() => {
          setState({ isPaneOpen: false });
        }}
      >
          <div className="col-xl-12">
            <div className="form-group row">
              <label className="col-lg-12 col-form-label">{t("As Of Date")}</label>
              <div className="col-lg-12">
                <select
                  className="form-control"
                  value={asOfDate}
                  onChange={(e) => setAsOfDate(e.target.value)}
                  disabled={isDatesLoading || availableDates.length === 0}
                  style={{ appearance: "auto" }}
                >
                  {availableDates.length === 0 ? (
                    <option value="">
                      {isDatesLoading ? t("Loading dates...") : t("No generated dates available")}
                    </option>
                  ) : (
                    availableDates.map((date, index) => (
                      <option key={index} value={date}>
                        {Helper.DateNormal(date)} 
                      </option>
                    ))
                  )}
                </select>
              </div>
            </div>
          </div>
         <div className="col-md-12">
          <label className="col-form-label">{t("Sub Company")}</label>
          <select className="form-select form-control" name="subcompany" onChange={(e) => setSubcompany(e.target.value)}>
            <option value="">Select Company</option>
            {subcompanyOptions.map((sub) => (
              <option key={sub.id} value={sub.id}>{sub.sub_company_name}</option>
            ))}
          </select>
        </div>
        <div className="col-md-12">
          <label className="col-form-label">{t("Line of Business")} </label>
          <select className="form-select form-control" name="lineOfBusiness" onChange={(e)=> setLineOfBusiness(e.target.value)}>
            <option value="">Select Line of Business</option>
            {lineOfBusinessOptions.map((lob) => (
              <option key={lob.id} value={lob.id}>{lob.lob_name}</option>
            ))}
          </select>
        </div>
        <div className="row">
          <div className="col-xl-12">
            <div className="form-group row">
              <label className="col-lg-12 col-form-label">{t("Customer Name")}</label>
              <div className="col-lg-12">
                <Select
                  value={selectedValue}
                  filterOption={false}
                  options={options}
                  isClearable
                  onInputChange={handelInputChange}
                  getOptionLabel={(options) => options.customer_name}
                  getOptionValue={(options) => options.customer_name}
                  isLoading={isLoading}
                  placeholder={t("Search for Customer(%for All)")}
                  onMenuScrollToBottom={handleMenuScrollToBottomName}
                  onChange={handelChange}
                />
              </div>
            </div>
          </div>
          <div className="col-xl-12">
            <div className="form-group row">
              <label className="col-lg-12 col-form-label">{t("Contract Number")}</label>
              <div className="col-lg-12">
                <Select
                  value={selectedValue2}
                  filterOption={false}
                  options={options2}
                  isClearable
                  onInputChange={handleInputChangeData}
                  getOptionLabel={(options) => options.contract_number}
                  getOptionValue={(options) => options.contract_number}
                  isLoading={isLoading2}
                  placeholder={t("Search for Contract(%for All)")}
                  onMenuScrollToBottom={handleMenuScrollToBottom}
                  onChange={handelChange2}
                />
              </div>
              <input type="hidden" id="contract_status" value="" />
            </div>
          </div>
          <div className="col-xl-12">
            <div className="form-group row">
              <div className="col-lg-12 text-left" style={{ marginTop: "30px" }}>
                <button type="button" className="clearReceipt btn bg-gradient-secondary ms-auto mb-0" onClick={handleClear}>
                  {t("RESET")}
                </button>
                &nbsp;&nbsp;
                <button type="button" className="filterReceipt btn btn-primary ms-auto mb-0" onClick={() => Helper.handleSearch(tableRef)}>
                  {t("Apply")}
                </button>
                &nbsp;&nbsp;
              </div>
            </div>
          </div>
        </div>
      </SlidingPane>
    </>
  );
}

export default DataTapeReport;